import React from 'react'
import './Anchor.css'

const anchor = (props) => (
	<div className='Anchor'>
		<div id={props.id}></div>
	</div>
)

export default anchor